import AnimatedIcon from "./AnimatedIcon";

const IconServers = ({ className = "", isOpen, hideText, delay = 0, labelPos = "l" }) => (
  <AnimatedIcon
    className={className}
    isOpen={isOpen}
    hideText={hideText}
    delay={delay}
    labelPos={labelPos}
    svgIcon={
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 181.84 111.37">
            <g fill="#FFFFFF">
                <path d="M135.58 0H45.64a4.33 4.33 0 0 0-4.33 4.33V107a4.33 4.33 0 0 0 4.33 4.33h89.94a4.33 4.33 0 0 0 4.33-4.33V4.33A4.33 4.33 0 0 0 135.58 0M45.64 3.22h89.94a1.11 1.11 0 0 1 1.11 1.11v31.4H44.53V4.33a1.11 1.11 0 0 1 1.11-1.11M136.69 39v33.2H44.53V39Zm-1.11 69.2H45.64a1.11 1.11 0 0 1-1.11-1.2V75.38h92.16V107a1.11 1.11 0 0 1-1.11 1.15ZM0 16v79a4.33 4.33 0 0 0 4.33 4.32H32.4v-3.19H4.33A1.11 1.11 0 0 1 3.22 95V16a1.11 1.11 0 0 1 1.11-1.11H32.4v-3.25H4.33A4.33 4.33 0 0 0 0 16M177.51 11.64h-28.07v3.22h28.07a1.11 1.11 0 0 1 1.11 1.14v79a1.11 1.11 0 0 1-1.11 1.1h-28.07v3.22h28.07a4.33 4.33 0 0 0 4.33-4.32V16a4.33 4.33 0 0 0-4.33-4.36"></path>
                <path d="M90.61 53.75h34.92v3.22H90.61z"></path>
                <circle cx="78.81" cy="55.51" r="2.87"></circle>
                <path d="M67.09 58.38a2.87 2.87 0 0 0 0-5.74 2.87 2.87 0 0 0 0 5.74M55.38 58.38a2.87 2.87 0 1 0-2.87-2.87 2.88 2.88 0 0 0 2.87 2.87M90.61 18.48h34.92v3.22H90.61z"></path>
                <circle cx="78.81" cy="20.23" r="2.87"></circle>
                <path d="M67.09 23.1a2.87 2.87 0 0 0 0-5.74 2.87 2.87 0 0 0 0 5.74M55.38 23.1a2.87 2.87 0 1 0-2.87-2.87 2.88 2.88 0 0 0 2.87 2.87M90.61 89.28h34.92v3.22H90.61zM78.81 88.16A2.87 2.87 0 1 0 81.68 91a2.88 2.88 0 0 0-2.87-2.84M67.09 88.16a2.87 2.87 0 0 0 0 5.74 2.87 2.87 0 0 0 0-5.74M55.38 88.16A2.87 2.87 0 1 0 58.25 91a2.87 2.87 0 0 0-2.87-2.84"></path>
            </g>
        </svg>
    }
    text={
      <>
        <span className="whitespace-nowrap">AI-Ready</span>
        <br />
        <span className="whitespace-nowrap">Data Centers</span>
      </>
    }
  />
);

export default IconServers;